import { create } from "zustand";

interface ToolbarOpenState {
  open: boolean;
  toggleState: () => void; // toggleState is a function that takes no arguments and returns void
}

const useToolbarStore = create<ToolbarOpenState>((set) => ({
  open: false,
  toggleState: () => set((state) => ({ open: !state.open })),
}));
export default useToolbarStore;
